module.exports = __webpack_public_path__ + "img/banner.96deb7c3.jpg";